import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import TabBar from "@/components/TabBar"
import styles from "@/styles/article/deliveryBrand.module.scss"
import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import Link from 'next/link'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function DeliveryBrand() {
  const [activeTab, setActiveTab] = useState(0)
  const tabList = [
    { id: 1, name: 'Tracking your package' }
  ]
  // 切换tab，展示不同的内容
  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  const router = useRouter()
  useEffect(() => {
    const { activeTab }: any = router.query

    // activeTab初始化赋值
    if (activeTab) {
      // 判断参数是否合规，合规参数才进行tab赋值
      let target = tabList.filter((item: any, index: number) => index == Number(activeTab))

      if (target.length) handleTabChange(Number(activeTab))
    }
  }, [router.query])


  return (
    <>
      <Head>
        <title>
          Return Policy - BestDeals.co.nz
        </title>
      </Head>

      <DefaultLayout>
        <div className={`${styles['page-delivery-brand']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          {/* banner图 */}
          <Image
            className={styles['delivery-banner']}
            src={`${imageDomain}/delivery-brand/delivery-banner.png`}
            alt={'male'}
            width={1200}
            height={135}
          ></Image>

          <div className={styles['delivery-content']}>
            <TabBar
              tabList={tabList}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />

            {
              activeTab === 0 &&
              <div className={styles['tab-one']}>
                <div className={styles['ask-title']}>How to Track Your Order?</div>
                <div className={styles['ask-title']}>Follow the steps below to check the progress of your parcel delivery.</div>

                <div className={`${styles['content-title-box']} margin-top-24`}>
                  <div className={styles['content-point']}>1</div>
                  <div className={styles['title-text']}>
                    {`Log in to your account, click on "My Account" in the top right corner, and then select "Order History"`}
                  </div>
                </div>

                <div className={styles['content-img-box']}>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p1.png`}
                    alt={'delivery'}
                    width={568}
                    height={240}
                  ></Image>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p2.png`}
                    alt={'delivery'}
                    width={568}
                    height={240}
                  ></Image>
                </div>

                <div className={`${styles['content-title-box']} margin-top-32`}>
                  <div className={styles['content-point']}>2</div>
                  <div className={styles['title-text']}>
                    {`After you are in the order list, find the order you want to check the logistics, and click “Track Order”, or click “View Detail” to go to the order details, and then click “Track Order”.`}
                  </div>
                </div>

                <div className={styles['content-img-box']}>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p3.png`}
                    alt={'delivery'}
                    width={568}
                    height={296}
                  ></Image>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p4.png`}
                    alt={'delivery'}
                    width={568}
                    height={296}
                  ></Image>
                </div>

                <div className={`${styles['content-title-box']} margin-top-32`}>
                  <div className={styles['content-point']}>3</div>
                  <div className={styles['title-text']}>
                    {`Copy the shipment number and click on the link at the bottom to check the delivery progress on the courier service website.`}
                  </div>
                </div>

                <div className={styles['content-img-box']}>
                  <Image
                    className={styles['content-img-big']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p5.png`}
                    alt={'delivery'}
                    width={927}
                    height={473}
                  ></Image>
                </div>

                <div className={`${styles['ask-title']} padding-top-24`}>Courier Service website</div>

                <div className={styles['answer-desc']}>
                  {`You can follow the steps above to check the delivery progress of your parcel, or select the tracking link for the courier company below to check (please make sure you have received the tracking number/logistics order number), or call the courier company to check.`}
                </div>

                <div className={styles['tips-text']}>
                  {`*Please make sure you have your tracking number handy before you click the tracking link.`}
                </div>


                <div className={styles['status-table']}>
                  <div className={styles['status-table-header']}>
                    <div className={styles['header-item']}>Courier Name</div>
                    <div className={styles['header-item']}>Tracking Link</div>
                    <div className={styles['header-item']}>Courier Phone Number</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Post Haste</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="http://www.posthaste.co.nz/tracktrace.html"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          http://www.posthaste.co.nz/tracktrace.html
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      09 579 2789
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Toll</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="http://fasttracker-nz.tollgroup.com/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          http://fasttracker-nz.tollgroup.com/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      /
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>International<br />Registered Post</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.aftership.com/track"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.aftership.com/track
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      /
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>StraitNZ</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="http://online.straitnz.co.nz/track_connote.asp"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          http://online.straitnz.co.nz/track_connote.asp
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      9 570 2674
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Australia Post</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://auspost.com.au/mypost/track/#/search"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://auspost.com.au/mypost/track/#/search
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      61 3 8340 7239<br />8am–6pm, Monday–Friday<br />(except national public holidays)
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>MainFreight</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.mainfreight.com/en-nz/tracking"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.mainfreight.com/en-nz/tracking
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      /
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Barlows</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://mydel.info/Track/47564/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://mydel.info/Track/47564/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      (+61) 2 4905 0805<br />(+64) 9883 0677
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Shippit</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.shippit.com/track-your-package"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.shippit.com/track-your-package
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      /
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Fliway</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://online.fliway.com/Public"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://online.fliway.com/Public
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      0800 354 929
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>NZ Post</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.nzpost.co.nz/tools/tracking"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.nzpost.co.nz/tools/tracking
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      64 9 977 0102<br />Monday to Friday, 8am to 6pm<br />(except national public holidays)
                    </div>
                  </div>
                </div>

                <div className={styles['answer-desc']}>
                  Welcome to <Link href={'https://www.bestdeals.co.nz/'} legacyBehavior><a rel="noopener noreferrer" className={styles['link']}>BestDeals.co.nz</a></Link>, where we make tracking your shipments easy and efficient. Our extensive logistics network offers various shipping options through a diverse range of couriers, including Post Haste, Toll, International Registered Post, StraitNZ, MainFreight, Barlows, Shippit, Fliway, NZ Post, and many more. As one of the largest online department stores in New Zealand, 100% owned and operated locally, we take pride in offering a seamless shopping and shipping experience. Our robust distribution channels and advanced logistics processes, supported by our dedicated team and expansive 15,000 sq ft warehouse, ensure that your orders are delivered swiftly and in optimal condition. With options that suit every preference, shipping with <Link href={'https://www.bestdeals.co.nz/'} legacyBehavior><a rel="noopener noreferrer" className={styles['link']}>BestDeals.co.nz</a></Link> is as convenient and reliable as finding the best deals on our site. Discover why shopping with us means efficient service, diverse courier choices, and savings all year round!
                </div>
              </div>
            }
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}